import { Component,OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { filter, map, mergeMap } from 'rxjs';

@Component({
  selector: 'app-custom-sharepoint',
  imports: [CommonModule],
  standalone: true,
  templateUrl: './custom-sharepoint.component.html',
  styleUrl: './custom-sharepoint.component.scss'
})
export class CustomSharepointComponent implements OnInit{
constructor(private router: Router, private activatedRoute: ActivatedRoute) { }
  nav(url: any) {
    console.log(url);   
    this.router.navigateByUrl(url)
  }
  ngOnInit(): void {
    this.router.events.pipe(
      filter((event: any) => event instanceof NavigationEnd),
      map(() => this.activatedRoute),
      map((route) => {
        while (route.firstChild) route = route.firstChild;
        return route;
      }),
      filter((route) => route.outlet === 'primary'),
      mergeMap((route: { data: any; }) => route.data)
    )
  }
}
